export default function getResource(label, vars = []) {
    const resources = {
        store: 'Magasin',
        edit: 'Modifier',
        pickAnArtist: 'Choisisir un(e) artiste',
        anyAvailableArtist: 'Tous les artistes disponibles',
        artistAvailabilityNotice: 'L’artiste peut changer en fonction de la disponibilité ce jour-là.',
        continueToReviewAndPay: 'Continuer pour Vérifier et payer',
        pickDateAndTime: 'Choisissez une date et une heure',
        showCalendar: 'Afficher le calendrier',
        timeSlotsTooltip: 'Time slots not displayed are fully booked.',
        morning: 'Morning',
        afternoon: 'Afternoon',
        evening: 'Evening',
        noAvailableTimes: 'No available times'
    };

    return resources[label];
}
